module.exports = __webpack_public_path__ + "static/media/page-rail-issuu.f19a09f5.gif";